// HM-370 cluster 16.4: client API CRUD buildings.

import { api } from './client.js';

export type Building = {
  id: string;
  tenantId: string;
  code: string;
  label: string;
  displayOrder: number;
  active: boolean;
  createdAt: string;
  updatedAt: string;
};

export async function listBuildings(): Promise<{ buildings: Building[] }> {
  return api('/buildings');
}

export async function createBuilding(body: {
  code: string;
  label: string;
  displayOrder?: number;
}): Promise<{ building: Building }> {
  return api('/buildings', { method: 'POST', body: JSON.stringify(body) });
}

export async function updateBuilding(
  id: string,
  patch: Partial<{ code: string; label: string; displayOrder: number; active: boolean }>,
): Promise<{ building: Building }> {
  return api(`/buildings/${id}`, { method: 'PATCH', body: JSON.stringify(patch) });
}

export async function deleteBuilding(id: string): Promise<{ ok: true } | { error: string }> {
  return api(`/buildings/${id}`, { method: 'DELETE', body: '{}' });
}
